export const GET_SETTINGS_BEGIN = "settings/GET_SETTINGS_BEGIN";
export const GET_SETTINGS_SUCCESS = "settings/GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_FAILURE = "settings/GET_SETTINGS_FAILURE";
export const SAVE_SETTINGS_BEGIN = "settings/SAVE_SETTINGS_BEGIN";
export const SAVE_SETTINGS_SUCCESS = "settings/SAVE_SETTINGS_SUCCESS";
export const SAVE_SETTINGS_FAILURE = "settings/SAVE_SETTINGS_FAILURE";
